<template>
  <div class="tour-image-gallery container">
    <div>
      <div class="photo-gallery">
        <!-- desktop -->
        <div class="desktop-images" @click="showImagesModal">
          <TourImageDisplayDesktop :images="images" />
        </div>
        <!--mobile-->
        <div class="mobile-images">
          <TourMobileSlider
            v-if="!isDesktop"
            ref="tourMobileSlider"
            class="photo-gallery-slider"
            :images="images"
            @clickImg="showImagesModal"
            @updateIdx="idx => goToIndex(idx)"
          />
        </div>
      </div>
      <!--model-->
      <div v-if="showModal" class="photo-gallery-modal">
        <GallerySlider
          class="tour-image-slider"
          :list="images"
          :initial-index="current"
          @closeGallery="closeImagesModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { delay } from '~/helpers/ui'
import imageOptimo from "@/mixins/imageOptimoMixin.js"
import GallerySlider from "@/components/containers/tour/GallerySlider"
import TourMobileSlider from "@/components/containers/tour/TourMobileSlider"
import TourImageDisplayDesktop from "@/components/containers/tour/TourImageDisplayDesktop"
export default {
  name: 'TourGallery',
  mixins: [imageOptimo],
  components: {
    GallerySlider,
    TourMobileSlider,
    TourImageDisplayDesktop
  },
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      current: 0,
      showModal: false,
    }
  },
  head() {
    const [first] = this.images
    const imgUrlForDesktop = this.getContentfulImgURL({
        url: first.url,
        width: 900,
        quality: 80,
      })
    const imgUrlForMobile = this.getContentfulImgURL({
        url: first.url,
        width: 600,
        height: 400,
        quality: 90,
        fit: 'pad',
        bgColor: 'rgb:000000'
      })
    return { link: [ {rel: 'preload', as: 'image', href: imgUrlForMobile }, {rel: 'preload', as: 'image', href: imgUrlForDesktop } ] }
  },
  computed: {
    ...mapGetters([
      'ua',
      'screenWidth'
    ]),
    isDesktop() {
      return this.screenWidth > 1024
    }
  },
  methods: {
    showImagesModal() {
      delay(() => {
        this.showModal = true
        document.body.style.position = 'fixed'
      });
    },
    closeImagesModal(newIndex) {
      delay(() => {
        this.showModal = false
        document.body.style.position = ''
        // this.goToIndex(newIndex)
        if (this.current !== newIndex && this.$refs?.tourMobileSlider) {
          // console.log('goTo new index => ', newIndex)
          this.$refs?.tourMobileSlider?.goTo(newIndex)
        }
      });
    },
    goToIndex(index) {
      if (index >= 0 && index < this.images.length) {
        this.current = index
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tour-image-gallery {
  // margin-top: 8px;
  width: 100% !important;
  section {
    padding: 0 !important;
  }

  height: auto;
  padding: 0;
  width: 100%;
  box-sizing: border-box;

  .photo-gallery {
    background-color: var(--surface-secondary);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    // min-height: 380px;

    .photo-gallery-slider::-webkit-scrollbar {
      display: none;
    }
    .desktop-images {
      width: 100%;
      height: 50vh;
      max-height: 400px;
      min-height: 380px;
    }
    .mobile-images {
      display: none;
    }
  }

  .photo-gallery-modal {
    -webkit-overflow-scrolling: touch;
    background: rgba(0, 0, 0, 0.85);
    bottom: 0;
    left: 0;
    outline: 0;
    overflow-y: auto;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 5000;
    box-sizing: border-box;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@include max-width($tablet) {
  .tour-image-gallery {
    margin-top: 4px;
    .photo-gallery {
      aspect-ratio: 3 / 2;
      .mobile-images {
        display: block;
      }
      .desktop-images {
        display: none;
      }
    }
  }
}
</style>
